module.exports = __webpack_public_path__ + "VIPV4.png?2904f1e8895badba321517d835d07626";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV4.png
// module id = 136
// module chunks = 0